module.exports = __webpack_public_path__ + "img/2.653a256d.png";